import React, { useEffect } from "react";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { useTheme } from "../../context/ThemeContext";
import { getCmsDataTableStyles } from "../../helpers/DataTableStyles";
import { invoiceAmount, formatInvoiceClientLabel } from "../../helpers/InvoiceHelper";
import { useFinancialYear } from "../../context/FinancialYearContext";
import InvoiceList from "../skeletons/InvoiceList";

export default function CreditNoteTables({
  data,
  loading,
  totalRows,
  page,
  limit,
  setPage,
  setLimit,
  fetchCreditNotes,
  curr_client_id,
  openDeleteCreditNoteModal,
}) {
  const { theme } = useTheme();
  const { financialYear } = useFinancialYear();

  useEffect(() => {
    fetchCreditNotes(limit, page, curr_client_id);
  }, [financialYear, curr_client_id, fetchCreditNotes, limit, page]);

  const columns = [
    {
      name: "#",
      width: "68px",
      cell: (row, index) => (page - 1) * limit + index + 1,
    },
    {
      name: "Client",
      grow: 2,
      cell: (row) => formatInvoiceClientLabel(row),
    },
    {
      name: "Credit note",
      cell: (row) => (
        <Link
          to={`/credit-notes/${row.credit_note_unique_id}/edit`}
          style={{ color: "#845adf" }}
        >
          {row.credit_note_number}
        </Link>
      ),
    },
    {
      name: "Ref. invoice",
      cell: (row) => row.ref_invoice_number || "—",
    },
    {
      name: "Date",
      selector: (row) => row.credit_note_bill_date,
    },
    {
      name: "Amount",
      cell: (row) => invoiceAmount(row.credit_note_type, row.credit_note_amount),
    },
    {
      name: "Action",
      width: "88px",
      cell: (row) => (
        <div className="hstack gap-1 justify-content-center flex-nowrap fs-15">
          <Link
            to={`/credit-notes/${row.credit_note_unique_id}/edit`}
            className="btn btn-icon btn-sm btn-info"
            title="Edit"
          >
            <i className="bx bxs-edit"></i>
          </Link>
          <button
            type="button"
            className="btn btn-icon btn-sm btn-danger"
            title="Delete"
            onClick={() => openDeleteCreditNoteModal(row)}
          >
            <i className="bx bxs-trash"></i>
          </button>
        </div>
      ),
    },
  ];

  return (
    <DataTable
      className="cms-data-table"
      columns={columns}
      data={data}
      progressPending={loading}
      progressComponent={<InvoiceList />}
      pagination
      paginationServer
      paginationTotalRows={totalRows}
      onChangePage={setPage}
      onChangeRowsPerPage={(newLimit, p) => {
        setLimit(newLimit);
        setPage(p);
      }}
      paginationPerPage={limit}
      customStyles={getCmsDataTableStyles(theme)}
      highlightOnHover
    />
  );
}
